import React from "react";
import Layout from "components/Layout";
import HomeBanner from "components/Section/HomeBanner";
import HomeServices from "components/Section/HomeServices";
import HomeClient from "components/Section/HomeClient";
import HomeFaq from "components/Section/HomeFaq";
import FormChoice from "components/Section/FormChoice";
import HomeMultipleSection from "components/Section/HomeMultipleSection";

const Home = () => {
  return (
    <Layout noBack selectedMenu="Home">
      <HomeBanner />
      <HomeServices />
      <HomeMultipleSection />
      <HomeClient />
      <HomeFaq />
      <FormChoice haveBackground />
    </Layout>
  );
};

export default Home;
